import {
  CategoryScale,
  Chart as ChartJS,
  ChartData,
  ChartOptions,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { CalculationResult } from '../types';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

interface ScenarioChartProps {
  result: CalculationResult;
}

export function ScenarioChart({ result }: ScenarioChartProps) {
  const data: ChartData<'line'> = {
    labels: result.annualSeries.map((row) => String(row.year)),
    datasets: [
      {
        label: '年度净减排',
        data: result.annualSeries.map((row) => row.net),
        borderColor: '#0f766e',
        backgroundColor: 'rgba(15, 118, 110, 0.18)',
        tension: 0.28,
      },
      {
        label: '年度现金流',
        data: result.annualSeries.map((row) => row.cashFlow),
        borderColor: '#b45309',
        backgroundColor: 'rgba(180, 83, 9, 0.14)',
        tension: 0.28,
      },
    ],
  };

  const options: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
    scales: {
      x: {
        grid: { color: 'rgba(100, 116, 139, 0.12)' },
      },
      y: {
        grid: { color: 'rgba(100, 116, 139, 0.12)' },
      },
    },
  };

  return (
    <div className="chart-shell">
      <Line data={data} options={options} />
    </div>
  );
}
